import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const useAssessment = () => {
  const { currentUser } = useAuth();
  const [assessment, setAssessment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAssessment = async () => {
      try {
        console.log('useAssessment: Starting...');
        console.log('useAssessment: currentUser:', currentUser?.uid);
        
        if (!currentUser) {
          console.log('useAssessment: No currentUser');
          setLoading(false);
          return;
        }

        // Get assessment directly from Firestore
        const assessmentDoc = await getDoc(doc(db, 'assessments', currentUser.uid));
        
        if (assessmentDoc.exists()) {
          const assessmentData = { id: assessmentDoc.id, ...assessmentDoc.data() };
          console.log('useAssessment: Assessment found:', assessmentData);
          setAssessment(assessmentData);
        } else {
          console.log('useAssessment: No assessment document found - user hasn\'t started yet');
          setAssessment(null);
        }

        console.log('useAssessment: ✅ Complete');
        setLoading(false);
      } catch (error) {
        console.error('useAssessment: ❌ Error:', error);
        setLoading(false);
      }
    };

    if (currentUser) {
      loadAssessment();
    } else {
      console.log('useAssessment: No currentUser, setting loading false');
      setLoading(false);
    }
  }, [currentUser]);

  return { assessment, loading };
};